import React, { Component, useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";

//Import Components
import MiniWidgets from "./MiniWidgets";
// Redux
import { connect, useDispatch } from 'react-redux';
import LoadingDialog from "../../components/Common/LoadingDialog";
import { useNavigate } from "react-router-dom";
import Notification from "../../components/Common/Notification";
import Footer from "../../components/VerticalLayout/Footer";
import SalesAnalytics from "./RevenueAnalytics";
import SalesByCategoryAnalytics from "./SalesAnalytics";
import { getDashboardInfo, resetDashboardState } from "../../store/actions";

const Dashboard = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setIsLoading] = useState(false);
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    useEffect(() => {
        dispatch(resetDashboardState());
        dispatch(getDashboardInfo());
    }, [])

    return (
        <React.Fragment>
            <div className="page-content" >
                <LoadingDialog open={loading || !props?.dashboardInfo} />
                <Notification notification={notification} setNotification={setNotification} />
                <Container fluid>

                    <div className="mb-1 justify-content-between d-flex align-items-center" style={{ fontSize: 16, fontWeight: '300' }}>
                        <div className="header">Overview</div>
                        <div className="subheader-2" style={{ color: '#686868' }}><i className="ri-calendar-line mx-1" />This Week</div>
                    </div>
                    <MiniWidgets reports={props?.dashboardInfo} />
                    <Row className="d-flex ">
                        <Col xl={8}>
                            {/* Sales Analytics */}
                            <SalesAnalytics sales={props?.dashboardInfo?.monthly_sales} totalSales={props?.dashboardInfo?.yearly_sales} />
                        </Col>
                        <Col xl={4} >
                            {/* Category Sales Analytics */}
                            <SalesByCategoryAnalytics sales={props?.dashboardInfo?.category_sales} />
                        </Col>
                    </Row>
                    <Row>
                        {/* sources */}
                        {/* <Sources /> */}

                        {/* earning reports */}
                        {/* <EarningReports /> */}
                        {/* recent activity */}
                        {/* <RecentlyActivity /> */}
                        {/* <ChatBox /> */}
                        {/* revenue by locations */}
                        {/* <RevenueByLocations/> */}
                    </Row>

                    <Row>
                        {/* chat box */}


                        {/* latest transactions */}
                        {/* <LatestTransactions/> */}
                    </Row>

                </Container>
            </div>
            <Footer></Footer>
        </React.Fragment>
    );

}

const mapStatetoProps = state => {
    const { loginError } = state.Login;
    return {
        loginError,
        dashboardInfo: state.Dashboard.dashboardInfo,
    };
}

// export default withRouter(connect(null, { verify_admin, getDashboardInfo })(Dashboard));
export default connect(mapStatetoProps)(Dashboard);
